import { useMemo, useState } from 'react';

import BoolEditableCell from '../cells/bool-editable';
import { QueryTable } from '../query-table';

export type CheckboxEditableBodyRender<T> = {
  selected: T[];
  onChange?(items: T[]): void;
};

export function checkboxBodyRender<T extends EntityBase>(props: CheckboxEditableBodyRender<T>) {
  // eslint-disable-next-line react/display-name
  return (_, { rowData }) => {
    const { loading, refetch } = QueryTable.useQueryTable();
    const [checked, setChecked] = useState(() => {
      return props.selected.some((value) => value.id === rowData.id);
    });

    return (
      <BoolEditableCell
        loading={loading}
        value={checked}
        onChange={(id, value) =>
          {
            if (!props.onChange) {return;}
            setChecked(value);
            if (value) {
              
              props.onChange([...props.selected, rowData]);
              return;
            }
            props.onChange([...props.selected.filter((item) => id !== item.id)]);
          }
        }
        rowId={rowData.id}
      />
    );
  };
}
